import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { ArrowRight } from "lucide-react";

const OnboardProductActions = ({
  isDataEngineerOrVendor,
  handleSaveDraft,
  isSaving,
  isSubmitting,
  isLoadingCodes,
  isLoadingDetails,
  allFilesConfigured,
  hasUploaded
}) => {
  return (
    <div className="mt-8 flex justify-between">
      <Tooltip
        title={
          isDataEngineerOrVendor
            ? "You are not authorized to save drafts"
            : ""
        }
        placement="top"
        arrow
      >
        <span>
          <button
            type="button"
            onClick={handleSaveDraft}
            className="px-4 py-2 border border-[#bb1ccc] text-white bg-[#bb1ccc] rounded-md hover:bg-[#000080] hover:border-[#000080] disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={
              isSubmitting ||
              isSaving ||
              isLoadingCodes ||
              isLoadingDetails ||
              isDataEngineerOrVendor
            }
          >
            {isSaving ? <span>Saving...</span> : "Save Draft"}
          </button>
        </span>
      </Tooltip>

      <Tooltip
        title={
          isDataEngineerOrVendor
            ? "You are not authorized to submit this form"
            : ""
        }
        placement="top"
        arrow
      >
        <span>
          <button
            type="submit"
            className="flex items-center justify-center h-[45px] min-w-[150px] px-4 bg-[#bb1ccc] text-white rounded-md hover:bg-[#000080] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={
              isSubmitting ||
              isSaving ||
              isLoadingCodes ||
              isLoadingDetails ||
              !allFilesConfigured ||
              isDataEngineerOrVendor ||
              hasUploaded && hasUploaded ? !hasUploaded : false
            }
          >
            {isSubmitting ? (
              <span>Submitting...</span>
            ) : (
              <>
                <span className="mr-2">Next Step</span>
                <ArrowRight className="h-4 w-4" />
              </>
            )}
          </button>
        </span>
      </Tooltip>
    </div>
  );
};

export default OnboardProductActions;


